import IAction from "./action";
import IMenu from "../../presentation/interfaces/menu";

const reducer = (state: IMenu, action: IAction): IMenu => {
  switch (action.type) {
    case "TOGGLE_MENU_DEVELOPER":
      return { ...state, developer: !state.developer };
    default:
      return state;
  }
};

export default reducer;
